import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { Navbar } from "../components/Navbar";
import { CheckCircle2, XCircle } from "lucide-react";

export default function ConfirmReview() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [state, setState] = useState("loading");

  useEffect(() => {
    api.post(`/disputes/confirm/${token}`)
      .then(() => setState("ok"))
      .catch(() => setState("error"));
  }, [token]);

  return (
    <div className="App bg-[#F4F7FA] min-h-screen">
      <Navbar />
      <div className="max-w-md mx-auto px-5 py-24 text-center" data-testid="confirm-review-page">
        {state === "loading" && <p className="text-slate-400">Confirming…</p>}
        {state === "ok" && (
          <>
            <CheckCircle2 className="w-14 h-14 text-mint mx-auto" />
            <h1 className="mt-4 font-heading font-extrabold text-3xl text-navy">Thank you — your review stands</h1>
            <p className="mt-2 text-slate-600">You've confirmed you stand by your statement, so your review will remain published.</p>
            <button onClick={() => navigate("/")} className="mt-6 bg-mint text-white font-semibold px-6 py-3 rounded-xl hover:bg-mint-dark transition-colors">Back to Tenverly</button>
          </>
        )}
        {state === "error" && (
          <>
            <XCircle className="w-14 h-14 text-red-500 mx-auto" />
            <h1 className="mt-4 font-heading font-extrabold text-3xl text-navy">Link invalid or already resolved</h1>
            <p className="mt-2 text-slate-600">This dispute may have already been confirmed or closed.</p>
          </>
        )}
      </div>
    </div>
  );
}
